export const actions = {
	async get(_, { companyId, creatorId }) {
		return await useNuxtApp().$api(`/api/company/${companyId}/point-transactions/`, {
			creator_id: creatorId,
		})
	},

	// params: creator_id, limit
	async list(_, { companyId, params }) {
		return await useNuxtApp()
			.$api(`/api/company/${companyId}/point-transactions/`, { params })
			.then((res) => {
				return res
			})
	},

	async get_page(_, { pageURL }) {
		return await useNuxtApp()
			.$api(pageURL)
			.then((res) => {
				return res
			})
	},

	async create(_, { companyId, data }) {
		return await useNuxtApp().$api(`/api/company/${companyId}/point-transactions/`, {
			method: 'POST',
			body: data,
		})
	},
}
